import React, { useEffect } from "react";
import "./aboutus.scss";
import Aboutushero from "../../components/Aboutushero/Aboutushero";
import Footer from "../../components/Footer/Footer";
import abs1 from "../../assets/Group39240.png";
import abs2 from "../../assets/Group39243.png";
import dabs1 from "../../assets/Frame39256.png";
import dabs2 from "../../assets/Group39265.png";
import dabs3 from "../../assets/Manwithsofabag.png";
import { useNavigate } from "react-router-dom";
const Aboutus = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = ` About Us | Ballers`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div>
      <Aboutushero />
      <div className="howdoyou_section">
        <div className="howdoyou_content">
          <div className="top">
            <div className="circle1"></div>
            <div className="rod1"></div>
            <div className="circle2"></div>
            <div className="rod2"></div>
          </div>
          <div className="bottom">
            <div className="circle1"></div>
            <div className="rod1"></div>
            <div className="circle2"></div>
            <div className="rod2"></div>
          </div>
          <div className="abs1">
            <img src={dabs1} alt="" />
          </div>
          <div className="abs2">
            <img src={dabs2} alt="" />
          </div>
          <div className="abs3">
            <img src={dabs3} alt="" />
          </div>
          <div className="title">
            <h2>How do you transcend the game?</h2>
          </div>
          <div className="info">
            <p>
              {" "}
              There was a time when sports was just about the game, when people
              played for the love of it, when clubs were more than just gyms,
              and when competition meant more than just a scoreboard.{" "}
              <strong>
                {" "}
                That time is coming back, but on our terms.{" "}
              </strong>{" "}
              Sports has evolved. It's no longer confined to stadiums or weekend
              games. <strong>
                {" "}
                It's culture. It's community. It's a way{" "}
              </strong>{" "}
              of life. But here's the problem, access to the best of it has been
              gated for too long.
              <br />
              <br />
              Traditional sports clubs? Outdated. Pay-per-use models?
              Transactional, not transformational. Ultra-exclusive country
              clubs? They were built for a different era.{" "}
              <strong>
                {" "}
                We're building what should have existed all along.{" "}
              </strong>
              <br />
              <br />
              <strong>
                Ballers is sports, reimagined for the next generation .
              </strong>
              <br />
              <br />
              <br />
            </p>
          </div>
        </div>
      </div>
      <div className="aboutbanner_wrapper">
        <div className="aboutbanner_content">
          <div className="heading">
            <h3>
              <div className="abs1">
                <img src={abs1} alt="" />
              </div>
              Join us at Ballers and live the most <br /> elite sports
              experience, Ever.
              <div className="abs2">
                <img src={abs2} alt="" />
              </div>
            </h3>
          </div>

          <button onClick={() => navigate("/signUp")}>Become a Member</button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Aboutus;
